import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormPayment from "../../components/Forms/FormPayment";
import PixPayment from "../../components/Forms/FormPix";
import FinishPayment from "../../components/finishPayment/finishPayment";
import CartCard from "../../components/cartCard/CartCard";
import styles from "./CheckoutPagamentoCartao.module.css";
import { Header } from "../../components/Header";
import { useCheckout } from "../../context/CheckoutContext";
import ApiService from "../../service/ApiService";
import { Constants } from "../../utils/constants";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const googleSiteKey = process.env.REACT_APP_GOOGLE_SITE_KEY || '';

const CheckoutPagamentoCartao: FunctionComponent = () => {
  const apiService = new ApiService();
  const navigate = useNavigate();
  const { paymentType, setPaymentType, cart, totalPrice } = useCheckout();
  const params = useParams()
  const [isCartCardVisible, setIsCartCardVisible] = useState(false);
  const [infoText, setInfoText] = useState("")
  const [disabled, setDisabled] = useState(true);

  const width = window.innerWidth;
  const cartCardRef = useRef(null);

  useEffect(() => {
    apiService
      .getTermsAndPolicy()
      .then(
        ({
          image_disclaimer_text,
        }) => {
          setInfoText(image_disclaimer_text);
        }
      );
  }, []);

  useEffect(() => {
    const elemento = document.getElementById('pagamento');
    if (cart.length === 0) params.slug ? navigate(`/${params.slug}`) : navigate("/");
    if (elemento) {
      elemento.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const cepDataLocalStorage =
      localStorage.getItem(Constants.LOCALSTORAGE.cepData);

    if (!cepDataLocalStorage) {
      params.slug
        ? navigate(`/checkout-entrega/${params.slug}`)
        : navigate('/checkout-entrega');
    }
  },[navigate])


  const onSeusDadosTextClick = useCallback(() => {
    if (!params.slug && !params.planSlug) {
      navigate("/checkout-dados");
    } else if (params.slug && !params.planSlug) {
      navigate(`/checkout-dados/${params.slug}`)
    } else if (params.slug && params.productSlug) {
      navigate(`/checkout-dados/${
          params.slug
        }/${params.planSlug}/${params.productSlug}`)
    } else if (params.planSlug && params.productSlug) {
      navigate(`/checkout-dados/${params.planSlug}/${params.productSlug}`)
    }
  }, [navigate]);

  const onSwitchPayment = (type: string) => {
    setPaymentType(type);
  };

  const openCartCardModal = () => {
    setIsCartCardVisible(!isCartCardVisible);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartCardRef.current && !cartCardRef.current.contains(event.target)) {
        setIsCartCardVisible(false);
      }
    };
    if (isCartCardVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCartCardVisible]);

  const changeDisabled = (value:boolean) => {
    setDisabled(value)
  }

  return (
    <div className={styles.checkoutPagamentoCartao}>
      {/* <div className={styles.header}> */}
        <Header path="/checkout-entrega" />
      {/* </div> */}
      <div className={styles.conteudo}>
        <div className={styles.colunaDireita}>
          <div className={styles.titulo}>
            <div className={styles.seusDados} onClick={onSeusDadosTextClick}>
              Seus dados
            </div>
            <div className={styles.divseta}>{`>`}</div>
            <div
              className={styles.endereoDeEntrega}
            >
              Endereço de entrega
            </div>
            <div className={styles.div}>{`>`}</div>
            <div className={styles.pagamento} id="pagamento">Pagamento</div>
          </div>
          <GoogleReCaptchaProvider reCaptchaKey={googleSiteKey}>
            {paymentType === "Cartão" ? (
                <FormPayment
                  googleSiteKey={googleSiteKey}
                  onSwitch={onSwitchPayment}
                  openModal={openCartCardModal}
                  setDisabled={changeDisabled}
                  disabled={disabled}
                  cvvTooltip="Código de segurança de 3 dígitos (ou 4 dígitos, para cartões American Express) encontrado no verso do seu cartão."
                  expirationTooltip="Data de vencimento do cartão, com 2 dígitos para o mês e 2 dígitos para o ano (ex.: 10/25)."
                />
            ) : (
                <PixPayment
                  googleSiteKey={googleSiteKey}
                  onSwitch={onSwitchPayment}
                  openModal={openCartCardModal}
                  setDisabled={changeDisabled}
                />
              )}
          </GoogleReCaptchaProvider>
          <p className={styles.infoText}>
            {
              infoText
            }
          </p>
        </div>

        {!isCartCardVisible && width < 800 && (
          <div className={
            (disabled && paymentType === 'Cartão') 
            ? styles.cta : styles.filledCart
          } 
            onClick={(disabled && paymentType === 'Cartão') ? () => {} : openCartCardModal}>
            <div className={styles.continuarCompra24}>
              <button
                className={styles.btnContinuarCompra}
                disabled={(disabled && paymentType === 'Cartão')}
                onClick={openCartCardModal}
              >
                Finalizar compra
              </button>
            </div>
            <img className={styles.icones133} alt="" src="/icones5.svg" />
          </div>
        )}
        {width > 800 ? (
          <div className={styles.colunaEsqueda}>
            <CartCard showProducts={true} onSwitch={onSwitchPayment} show={{ discount: true, coupon: true }} />
          </div>
        ) : (
          <>
            <div className={styles.cartIconBox} onClick={openCartCardModal}>
              <svg
                className={styles.cartIcon}
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="27"
                viewBox="0 0 576 512"
              >
                <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
              </svg>
            </div>
            {/* <div className={styles.botao4} onClick={openCartCardModal}>
              <div className={styles.cta10}>
                <img className={styles.icones132} alt="" src="/icones4.svs" />
                <div className={styles.continuarCompra24}>Finalizar compra</div>
                <img className={styles.icones133} alt="" src="/icones5.svg" />
              </div>
            </div> */}
          </>

        )}

        {isCartCardVisible && width < 800 && (
          <div
            className={`${styles.cartCardModal} ${
              isCartCardVisible ? styles.showModal : ""
            }`}
          >
            <div className={styles.cartCardContent} ref={cartCardRef}>
              <CartCard showProducts={true} show={{ discount: true, coupon: true }} />
              <GoogleReCaptchaProvider reCaptchaKey={googleSiteKey}>
                <FinishPayment disabled={disabled} paymentType={paymentType}/>

              </GoogleReCaptchaProvider>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutPagamentoCartao;
